export const STORAGE_KEYS = {
  DARK_MODE: 'dark-mode',
  LANGUAGE: 'language',
  // Key to prevent showing the splash screen again after user logs out
  HAS_LOGGED_OUT: 'has-logged-out',
};
